import http, { httpV2 } from "../http.js";

const HolidaysService = {
  getHolidays: (params) => httpV2.get("/holidays", { params }),

  insertHoliday: (objHoliday) => httpV2.post("/holidays", objHoliday),

  updateHoliday: (objHoliday) =>
    httpV2.put(`/holidays/${objHoliday.holiday_id}`, objHoliday),

  deleteHoliday: (objHoliday) =>
    httpV2.delete(`/holidays/${objHoliday.holiday_id}`),

  preloadNationalHolidays: ({ year, country }) =>
    httpV2.post("/holidays/preload", { year, country }),
};

export default HolidaysService;